import type { CharacterDef } from '@md/engine';
import {
  TILE_CHARGED_BLUE_CHAR,
  TILE_CHARGED_RED_CHAR,
  TILE_COPPER_CHAR,
  TILE_STEEL_CHAR,
} from './tiles.js';

/**
 * Le duo de Magnetic Duo (concept §2).
 *
 * L'index 0 correspond au marqueur `P` de la carte ASCII, l'index 1 à `M`.
 *
 * | | Polo | Mag |
 * |---|---|---|
 * | Pôle | Nord `+` | Sud `−` |
 * | Accroche | cuivre `c` | acier `s` |
 * | Mortel | dalle bleue `-` | dalle rouge `+` |
 */
export const POLO: CharacterDef = {
  id: 'polo',
  name: 'Polo',
  tint: 0xff4d5e,
  clingSurfaces: [TILE_COPPER_CHAR],
  lethalTiles: [TILE_CHARGED_BLUE_CHAR],
};

export const MAG: CharacterDef = {
  id: 'mag',
  name: 'Mag',
  tint: 0x35c8ff,
  clingSurfaces: [TILE_STEEL_CHAR],
  lethalTiles: [TILE_CHARGED_RED_CHAR],
};

export const CHARACTERS: readonly [CharacterDef, CharacterDef] = [POLO, MAG];

/** Pôle au repos de chaque personnage : +1 = Nord (Polo), -1 = Sud (Mag). */
export const BASE_POLARITY: Readonly<Record<string, number>> = Object.freeze({
  [POLO.id]: 1,
  [MAG.id]: -1,
});
